export enum ReturnCodeAgeType {
  OLDER_THAN_30_DAYS = 'OLDER_THAN_30_DAYS',
  OLDER_THAN_60_DAYS = 'OLDER_THAN_60_DAYS',
  OLDER_THAN_90_DAYS = 'OLDER_THAN_90_DAYS',
}
